import { hasUpdate } from "@/helpers/hooks/hasUpdate.ts";
import { useNewVersionStore } from "@/stores/NewVersionStore/NewVersionStore.ts";
import { useEffect } from "react";

const handleUpdateToNewVersion = () => {
  const resetNewVersionStore = useNewVersionStore.getState().resetStore;

  resetNewVersionStore();
  window.location.href = `${window.location.origin}${window.location.pathname}?t=${new Date().getTime()}`;
};

export const useCheckNewVersion = () => {
  useEffect(() => {
    const checkForUpdate = async () => {
      const updateAvailable = await hasUpdate();
      if (updateAvailable) handleUpdateToNewVersion();
    };

    // Check for updates immediately on load
    void checkForUpdate();

    // Check for updates periodically (every 1 minute)
    const intervalId = setInterval(checkForUpdate, 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);
};
